import { SegmentedControl, TextField } from "@hamlak/ui";
import type { Gender } from "@/api/types";
import { t } from "@/i18n/ko";

export const PROFILE_NAME_MAX = 12;
export const PROFILE_BIO_MAX = 1000;
const GENDERS: readonly { value: Gender; label: string }[] = [
  { value: "female", label: t("profile.gender.female") },
  { value: "male", label: t("profile.gender.male") },
  { value: "none", label: t("profile.gender.none") },
];

export type ProfileFormValue = { name: string; bio: string; gender: Gender };

/**
 * 대화 프로필 입력 필드(이름·소개·성별 + 기본 프로필 안내). 생성(/profile/new)과 편집(/profile/:id/edit)이 공유하는 controlled 컴포넌트.
 * 사진 UI 없음(spec 7절). 기본 안내는 첫 프로필 생성에서만 보인다.
 */
export function ProfileForm({
  value,
  onChange,
  errors,
  showDefaultNotice,
}: {
  value: ProfileFormValue;
  onChange: (v: ProfileFormValue) => void;
  errors?: { name?: string | undefined };
  showDefaultNotice: boolean;
}) {
  return (
    <>
      <TextField
        label={t("profile.name")}
        description={t("profile.name.description")}
        placeholder={t("profile.name.placeholder")}
        value={value.name}
        onValueChange={(name) => onChange({ ...value, name })}
        maxLength={PROFILE_NAME_MAX}
        {...(errors?.name ? { error: errors.name } : {})}
        autoComplete="nickname"
      />
      <TextField
        multiline
        label={t("profile.bio")}
        placeholder={t("profile.bio.placeholder")}
        value={value.bio}
        onValueChange={(bio) => onChange({ ...value, bio })}
        maxLength={PROFILE_BIO_MAX}
        rows={4}
      />
      <div className="profile__field">
        <span className="profile__field-label">{t("profile.gender")}</span>
        <SegmentedControl aria-label={t("profile.gender")} options={GENDERS} value={value.gender} onChange={(gender) => onChange({ ...value, gender })} />
      </div>
      {showDefaultNotice ? (
        // 첫 프로필은 항상 기본 — 스위치 없이 안내만(시안 F01-05)
        <div className="profile__default">
          <div className="profile__default-text">
            <span id="profile-default-title" className="profile__default-title">
              {t("profile.default")}
            </span>
            <span className="profile__default-description">{t("profile.default.description")}</span>
          </div>
        </div>
      ) : null}
    </>
  );
}
